import $ from "jquery";

export default function initHeaderMenu() {
    const $header = $('header.header');
    if (!$header.length) return;

    const $nav = $header.find('#main-menu');
    const $menuButton = $header.find('#menu-toggle');
    const $overlay = $('#body-overlay');

    if (!$nav.length || !$menuButton.length) return;

    const $submenuToggles = $nav.find('.js-submenu-toggle');
    const $menuItemsWithChildren = $nav.find('.menu-item-has-children');

    let scrollY = 0;

    $submenuToggles.on('click', function (e) {
        e.preventDefault();

        const $toggle = $(this);
        const $menuItem = $toggle.closest('.menu-item-has-children');
        const $submenu = $toggle.siblings('.sub-menu');

        const isActive = $toggle.hasClass('active');

        $toggle.toggleClass('active', !isActive);
        $menuItem.toggleClass('active', !isActive);

        if (isActive) {
            $submenu.slideUp();
        } else {
            $submenu.slideDown();
        }
    });

    const lockScroll = () => {
        scrollY = window.scrollY;

        document.documentElement.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = '100%';
    };

    const unlockScroll = () => {
        document.documentElement.style.overflow = '';

        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';

        window.scrollTo(0, scrollY);
    };

    const resetSubmenus = () => {
        $submenuToggles.removeClass('active');
        $menuItemsWithChildren.removeClass('active');
    };

    const openMenu = () => {
        $nav.slideDown();
        $menuButton.addClass('active');
        $overlay.addClass('active');

        lockScroll();
    };

    const closeMenu = (withAnimation = true) => {
        if (withAnimation) {
            $nav.slideUp();
            $nav.find('.sub-menu').slideUp();
        } else {
            $nav.css('display', '');
            $nav.find('.sub-menu').css('display', '');
        }

        $menuButton.removeClass('active');
        $overlay.removeClass('active');

        unlockScroll();
        resetSubmenus();
    };

    $menuButton.on('click', function (e) {
        e.preventDefault();

        if ($menuButton.hasClass('active')) {
            closeMenu();
        } else {
            openMenu();
        }
    });


    $overlay.on('click', closeMenu);

    $(window).on('resize', () => {
        if ($(window).width() > 767) {
            closeMenu(false);
        }
    });
}